import { render } from "./bannerBottom.vue?vue&type=template&id=b47262de&scoped=true"
import script from "./bannerBottom.vue?vue&type=script&lang=js"
export * from "./bannerBottom.vue?vue&type=script&lang=js"

import "./bannerBottom.vue?vue&type=style&index=0&id=b47262de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b47262de"]])

export default __exports__